import { useState, useEffect } from 'react';

export const useDadosExame = (
    exameSelecionado
) => {
    const [material, setMaterial] = useState('');
    const [conservante, setConservante] = useState('');
    const [dadosExame, setDadosExame] = useState({
        exame: null,
        especificacao: ''
    });

    useEffect(() => {
        setDadosExame({
            exame: exameSelecionado
                ? {
                    mnemonico: exameSelecionado.mnemonico,
                    material: exameSelecionado.material,
                    nome: exameSelecionado.nome
                }
                : '',
            especificacao: exameSelecionado ? exameSelecionado.descricaoMaterial : ''
        });
        setMaterial(exameSelecionado ? exameSelecionado.codigoMaterial : '');
        setConservante(exameSelecionado ? exameSelecionado.codigoConservante : '');
    }, [exameSelecionado]);

    const handleChangeExame = (campo, eventoOuValor) => {
        setDadosExame({ ...dadosExame, [campo]: eventoOuValor });
    };

    const limparExame = () => {
        setDadosExame({
            exame: null,
            especificacao: dadosExame.especificacao
        });
    }

    return {
        ...dadosExame,
        material,
        conservante,
        handleChangeConservante: setConservante,
        handleChangeMaterial: setMaterial,
        handleChangeExame: handleChangeExame,
        limparExame: limparExame
    };
};